import React from 'react';
import { Accordion, AccordionSummary, Typography, AccordionDetails, makeStyles, Box } from '@material-ui/core';
import RemoveIcon from '@material-ui/icons/Remove';

const LoyaltyFaq = ({ isExpanded = false, title, children }) => {
    const classes = useStyles();
    const [expanded, setExpanded] = React.useState(isExpanded);

    const handleChange = () => {
        setExpanded(!expanded);
    };

    const renderToggleIcon = () => {
        return (
            <Box className={classes.toggleIconWrap}>
                <RemoveIcon className={classes.toggleIcon1} color="primary" />
                <RemoveIcon className={classes.toggleIcon2} color="primary" style={{ opacity: expanded ? 0 : 1 }} />
            </Box>
        );
    };

    return (
        <div>
            <Box mb={3}>
                <Accordion expanded={expanded} onChange={handleChange} elevation={0}>
                    <AccordionSummary expandIcon={renderToggleIcon()} id="panel1bh-header" className={classes.accordionHeader}>
                        <Typography variant="body2" className={classes.heading}>
                            {title}
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.accordionContent}>{children}</AccordionDetails>
                </Accordion>
            </Box>
        </div>
    );
};

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
    },
    heading: {
        fontFamily: 'Lato-Bold',
        textTransform: 'uppercase',
        color: '#3A3A3A',
        padding: theme.spacing(2, 2),
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    toggleIconWrap: {
        position: 'relative',
        width: 24,
        height: 24,
    },
    toggleIcon1: {
        position: 'absolute',
        top: 0,
        left: 0,
    },
    toggleIcon2: {
        position: 'absolute',
        top: 0,
        left: 0,
        transform: 'rotate(90deg)',
    },
    accordionContent: {
        padding: theme.spacing(4),
        paddingTop: 0,
    },
    accordionHeader: {
        '& .MuiAccordionSummary-expandIcon': {
            margin: 0,
        },
    },
}));

export default LoyaltyFaq;
